<template>
    <div class="toolbar">
        <el-row type="flex" class="row-bg" justify="" :gutter="5">
            <el-col :span="4">
              <div class="grid-content language-container">
                  <el-select
                    v-model="country"
                    placeholder="Select Country"
                    v-on:change="getLanguageWhileSetCountries"
                    clearable>
                      <el-option
                        v-for="item in countryOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value">
                        {{item.label}}
                      </el-option>
                  </el-select>
              </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content language-container">
                    <el-select
                      v-model="language"
                      placeholder="Select Language"
                      v-on:change="setData"
                      name="languageOptions"
                      clearable>
                        <el-option
                          v-for="item in languageOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          {{item.label}} | {{ item.value }}
                        </el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col v-if="!language" :span="4">
                <div class="grid-content">
                    <el-popover
                      placement="top"
                      v-model="visibleLangPopOver">
                      <el-form
                        v-loading="isLoading"
                        :model="form"
                        :rules="formRules"
                        ref="form"
                        label-width="120px"
                        class="demo-ruleForm">
                        <el-form-item label="language name" prop="newLanguage">
                          <el-input v-model="form.newLanguage"></el-input>
                        </el-form-item>
                        <el-form-item label="language code" prop="newLanguageCode">
                          <el-input v-model="form.newLanguageCode"></el-input>
                        </el-form-item>
                        <el-form-item style="display:flex;justify-content: space-evenly;">
                          <el-button
                          class="add-language-btn"
                          v-if="!language"
                          @click="addLanguage('form')">
                            Add Language
                          </el-button>
                          <el-button
                            @click="visibleLangPopOver = false,
                            resetForm('form')">
                            cancel
                          </el-button>
                        </el-form-item>
                      </el-form>
                      <el-button
                        disabled
                        type="primary"
                        plain slot="reference"
                        @click="visibleLangPopOver = true">
                        <div>Add language</div>
                      </el-button>
                    </el-popover>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content">
                    <el-select
                      v-model="textFile"
                      placeholder="Select Text"
                      v-if="language"
                      v-on:change="setTextFile"
                      clearable>
                        <el-option-group
                          v-for="group in textOptions"
                          :key="group.title"
                          :label="group.title">
                        <el-option
                          v-for="option in group.options"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value">
                        </el-option>
                        </el-option-group>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="16" v-if="textIsLoaded">
                <div class="grid-content">
                    <el-button
                      @click="toggleEditor"
                      type="success">
                        editor
                    </el-button>
                    <el-button
                      type="primary"
                      icon="el-icon-refresh"
                      @click="freshTextFile">
                    </el-button>
                    <el-button
                        icon="el-icon-document"
                        @click="openDialoge">
                        Preview Text
                    </el-button>
                    <el-button
                        type="success"
                        icon="el-icon-upload"
                        @click="uploadTextSignal">
                        Save Text
                    </el-button>
                    <dropDown style="margin-left: 5px;"></dropDown>
                </div>
            </el-col>
        </el-row>
        <CCInfoDialogue />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { Notification } from 'element-ui';
import dropDown from '@/components/CollectConsent/dropDown.vue';
import CCInfoDialogue from '@/components/CollectConsent/CCInfoDialogue.vue';
import dataBaseConnection from '@/mixins/dataBaseConnection.mixins';
import errorHandler from '@/mixins/errorHandler.mixins';
import Firebase from '../../fireBaseInit';

export default {
  components: {
    dropDown,
    CCInfoDialogue,
  },
  mixins: [
    dataBaseConnection,
    errorHandler,
  ],
  computed: {
    ...mapGetters([
      'textIsLoaded',
    ]),
    showEditor: {
      get() {
        return this.$store.getters.showEditor;
      },
      set(value) {
        this.$store.commit('openEditor', value);
      },
    },
  },
  created() {
    this.getFileData();
  },
  data() {
    const newLanguageInputCheck = (rule, value, callback) => {
      if (/\s/.test(value)) {
        // It has any kind of whitespace
        callback(new Error('Input cannot contain any spaces'));
      } else if (/^[a-zA-Z]*$/.test(value) === false) {
        // It has other characters then letters
        callback(new Error('Input may not have any characters other than letters'));
      } else {
        callback();
      }
    };
    return {
      language: '',
      countryCode: '',
      country: '',
      textFile: '',
      newLanguageCode: '',
      newLanguage: '',
      fileCount: 0,
      callCount: 0,
      editorDialogVisible: false,
      form: {
        newLanguageCode: '',
        newLanguage: '',
      },
      formRules: {
        newLanguageCode: [
          { required: true, message: 'Please give a languagecode', trigger: 'blur' },
          {
            min: 2, max: 2, message: 'Length should be 2', trigger: 'blur',
          },
          {
            validator: newLanguageInputCheck, trigger: 'blur',
          },
        ],
        newLanguage: [
          { required: true, message: 'Please give a language name', trigger: 'blur' },
          { min: 4, message: 'Length should be a minimum of 4', trigger: 'blur' },
          {
            validator: newLanguageInputCheck, trigger: 'blur',
          },
        ],
      },
      isLoading: false,
      visibleLangPopOver: false,
      languageOptions: [
        {
          label: '',
          value: '',
        },
      ],
      countryOptions: [
        {
          label: '',
          value: '',
        },
      ],
      textOptions: [
        {
          options: [{
            isRead: Boolean,
            label: '',
            value: '',
          }],
          title: '',
        },
      ],
    };
  },
  methods: {
    async getTextOptions() {
      const textOptionsData = await this.getDBDataMixin('textOptions', 'textFileNames').then(result => result)
        .catch((error) => {
          this.errorHandlerMixin(error);
        });

      this.textOptions = textOptionsData.textOptions;
    },
    async getCountries() {
      const languageOptionsData = await this.getAllDocumentsMixin('countries').then(result => result)
        .catch((error) => {
          this.errorHandlerMixin(error);
        });
      const { countries } = languageOptionsData;

      this.countryOptions = Object.keys(countries).map(key => ({
        label: countries[key].countries,
        value: countries[key].countries,
      }));
    },
    async getLanguages() {
      const languages = [];

      await this.getDBDataMixin('countries', this.country).then((result) => {
        this.countryCode = result.countryCode;
        languages.push(result.languages);
      }).catch((error) => {
        this.errorHandlerMixin(error);
      });

      const languageOptions = Object.keys(languages)
        .map(element => Object.keys(languages[element])
          .map(item => ({
            label: item,
            value: languages[element][item],
          })));

      [this.languageOptions] = languageOptions;
    },
    getFileData() {
      this.getCountries();
      this.getTextOptions();
    },
    addLanguageToDB(newLanguage, newLanguageCode) {
      const langDocRef = Firebase.fireStoreDB.collection('languageOptions').doc('languages');
      return langDocRef.update({
        [newLanguage]: newLanguageCode,
      })
        .then(() => {
          this.getFileData();
        })
        .catch((error) => {
          // A document probably doesn't exist.
          console.error('Error updating document: ', error);
        });
    },
    storeNewFiles(fileName, fileData) {
      const storageRef = Firebase.storage.ref();
      const data = JSON.stringify(fileData).replace(/\\n/g, '<br>');
      const blob = new Blob([data], { type: 'application/json' });
      const metadata = {
        contentType: 'application/json',
      };
      const uploadTask = storageRef.child(`collectconsent/cc-texts/${this.form.newLanguageCode}/${fileName}.${this.form.newLanguageCode}.json`).put(blob, metadata);
      // 1st function is for tracking state, 2nd is for errors,
      // 3th function handle succes (not used here)
      uploadTask.on('state_changed', () => { /* notused */ }, (error) => {
        Notification({
          title: 'Warning',
          message: error.message,
          type: 'warning',
        });
      });

      this.callCount = 1 + Number(this.callCount);

      if (Number(this.fileCount) === Number(this.callCount)) {
        this.addLanguageToDB(this.form.newLanguage, this.form.newLanguageCode);
        this.callCount = 0;
        this.form.newLanguageCode = '';
        this.form.newLanguage = '';
        this.resetForm('form');
        Notification({
          type: 'success',
          message: 'language is created',
          title: 'Success!!',
        });
      }
    },
    duplicateFiles(downloadUrls) {
      const vm = this;
      const { data } = downloadUrls;
      this.fileCount = Object.keys(data).length;
      Object.keys(data).map((fileName) => {
        axios.get(data[fileName]).then((response) => {
          const fileData = response.data;
          vm.storeNewFiles(fileName, fileData);
        }).catch((error) => {
          Notification({
            title: 'Warning',
            message: error.message,
            type: 'warning',
          });
        });
        // solves: eslint (array-callback-return)
        return true;
      });
    },
    getDownLoadUrls() {
      const vm = this;
      this.getDBDataMixin('ccTextFileDownloadUrls', 'downLoadLinks').then((downloadUrls) => {
        vm.duplicateFiles(downloadUrls);
      }).catch((error) => {
        Notification({
          title: 'Warning',
          message: error,
          type: 'warning',
        });
        console.log(error);
      });
    },
    addLanguage(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const currentLanguageData = this.languageOptions;
          const newCode = this.form.newLanguageCode;
          const newLang = this.form.newLanguage;

          function langCodeExistsCheck(newCode) { // eslint-disable-line
            return currentLanguageData.some(currentLangObj => currentLangObj.value === newCode);
          }

          function langExistsCheck(newLang) { // eslint-disable-line
            return currentLanguageData.some(currentLangObj => currentLangObj.label === newLang);
          }

          const langCodeExists = langExistsCheck(newCode);
          const langExists = langExistsCheck(newLang);

          if (!langCodeExists && !langExists) {
            this.getDownLoadUrls();
          } else {
            Notification({
              title: 'Language Exists',
              messasge: 'This language or language code does already exist',
              type: 'warning',
            });
            this.resetForm(formName);
          }
        } else {
          Notification({
            type: 'warning',
            message: 'wrong input',
            title: 'Wrong input',
          });
          console.log('error submit!!');
          this.resetForm(formName);
          return false;
        }

        // solves es-lint (consistent-return)
        return true;
      });
    },
    resetForm(formName) {
      this.isLoading = false;
      this.$refs[formName].resetFields();
    },
    getLanguageWhileSetCountries() {
      this.language = '';
      this.getLanguages();
    },
    setData() {
      if (this.countryCode) {
        this.$store.commit('getCountry', this.countryCode);
      } else {
        this.errorHandlerMixin('countryCode is undefined');
      }

      if (this.language) {
        this.$store.commit('getLanguage', this.language);
      } else {
        this.errorHandlerMixin('languageCode is undefined');
      }
    },
    setTextFile() {
      if (this.textFile) {
        this.$store.commit('getTextFile', this.textFile);
      } else {
        this.errorHandlerMixin('textFile is undefined');
      }
    },
    openDialoge() {
      // trigger event in sibbeling
      this.$store.commit('openTextPreview', true);
    },
    freshTextFile() {
      // trigger event in sibbeling
      this.$store.commit('freshTextFile', true);
    },
    uploadTextSignal() {
      // trigger event in sibbeling
      this.$store.commit('signalTextUpload', true);
    },
    toggleEditor() {
      this.showEditor = !this.showEditor;
      this.$store.commit('openEditor', this.showEditor);
    },
  },
};
</script>

<style lang="scss" scoped>
  .language-container {
    display: flex;

    .add-language-btn {
      position: relative;
      left: 70px;
      margin-left: -65px;
    }
  }
</style>
